<template>
  <div>
    <v-divider class="mt-5 mb-10" />

    <div v-if="isLoading && !successData" class="text-center py-15">
      <v-progress-circular :width="3" color="primary" indeterminate />
    </div>

    <div class="text-center" v-if="successData">
      <h1 class="mt-8 mb-2 mx-auto mw-400">
        {{ $t('onboarding.payment.pix.withPix') }}
      </h1>

      <p class="mw-300 mx-auto">
        {{ $t('onboarding.payment.pix.description') }}
      </p>

      <img
        v-if="successData"
        alt="PIX QR CODE"
        width="300"
        height="auto"
        :src="`data:image/jpeg;base64,${successData.pix_qrcode_image}`"
      />

      <v-divider class="my-8" />

      <v-textarea
        v-if="successData"
        :value="successData.pix_string_code"
        outlined
        readonly
        small
      />

      <div class="d-flex justify-center">
        <v-chip>
          <v-progress-circular
            :size="10"
            :width="1"
            class="mr-2"
            indeterminate
          />
          {{ $t(`onboarding.payment.pix.status.${successData.status}`) }}
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'OnboardingPix',

  props: {
    paymentType: {
      type: String,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters([
      'pixData',
      'successData',
      'isLoading',
      'onboardingStepsNavigation',
    ]),
  },

  methods: {
    ...mapMutations(['setOnboardingStepsNavigation']),
    ...mapActions(['refreshPixRecharge', 'showErrorMessage']),

    handleErrorMessage(data) {
      data?.errors && data?.errors?.length >= 1
        ? this.showErrorMessage(data.errors[0].message)
        : this.showErrorMessage(data.message)
    },
  },

  watch: {
    pixData(value) {
      if (
        this.onboardingStepsNavigation === 5 &&
        (value?.status === 'RECEIVED' || value?.status === 'CONFIRMED')
      ) {
        clearInterval(this.interval)

        api
          .post('web/customerOnboarding/setNoServiceStatus')
          .then(() => this.setOnboardingStepsNavigation(9))
          .then(() => this.$emit('clearRefreshInterval'))
          .catch(({ data }) => this.handleErrorMessage(data))
      }
    },
  },
}
</script>
